import React from 'react';
import prospectImage from '../../../images/mailer-survey-request-new-prospect.png';
import StaticPages from '..';

interface PropTypes {
  url: string;
}

export default function ConnectCalendar(props: PropTypes) {
  const handleConnectCalendar = () => {
    window.location.href = props.url;
  };

  return (
    <StaticPages
      mainText='You need to connect your calendar'
      prospectImage={prospectImage}
      secondaryText={
        <>
          To be able to schedule interviews, click the button below
          <br />
          and connect your calendar.
        </>
      }
      handleOnClick={handleConnectCalendar}
      buttonText='Connect Calendar'
    />
  );
}
